import {DefaultAction, DefaultNatural} from "../Action";

export default {
  ...DefaultAction,
  ...DefaultNatural,
  getUse() { return [] },
  successEventsPerTarget() { return [] }
}